<template
  id="care-home-list-template"
>
  <slot
    name="content"
    :toggleCompareList="toggleCompareList"
    :compareStore="compareStore"
    :closeCompareList="closeCompareList"
    :submitCompareNow="submitCompareNow"
    :toggleMap="toggleMap"
    :showFullMap="data.showFullMap"
    :clickTile="clickTile"
    :showCareHomeForm="showCareHomeForm"
    :isCompareChecked="isCompareChecked"
    :addRemoveToCompareList="addRemoveToCompareList"
    :shouldStick="data.shouldStick"
    :printCompare="printCompare"
    :toggleModal="toggleModal"
    :removeSelectedCompareItem="removeSelectedCompareItem"
    :showManagerNumber="showManagerNumber"
    :compareActiveNumberId="data.compareActiveNumberId"
    ></slot>
</template>
<script setup>
import {defineProps, reactive, onMounted, nextTick} from 'vue';
import useGlobalStore from '../../store/globalStore'
import useCompareStore from '../../store/compareStore'
import useFilterStore from '../../store/filterStore'
import {useRestHomeCompare} from '../../composables/useRestHomeCompare'
import {useFormSubmit} from '../../composables/useFormSubmit'
import {useCommon} from "../../composables/useCommon";

const { clickTile } = useFormSubmit()
const { productImpression } = useCommon()
const { showCareHomeForm, isCompareChecked, addRemoveToCompareList, printCompare, removeSelectedCompareItem } = useRestHomeCompare()

const props = defineProps({
  compareList: {
    type: Array,
    default: () => [],
  },
  careHomeImpressionList: {
    type: Object,
    default: () => {},
  },
});

const globalStore = useGlobalStore()
const compareStore = useCompareStore()
const filterStore = useFilterStore()
const data = reactive({
  showTypeOfRooms: false,
  showFilter: true,
  shouldStick: true,
  showMap: false,
  showFullMap:false,
  compareList: props.compareList,
  controls: [
    '<i class=\'icon icon--arrow-left\'></i>',
    '<i class=\'icon icon--arrow-right\'></i>'
  ],
  compareActiveNumberId: false,
  mySiteKeyVariable: null,
  isMobileFilterOn: false,
});

// Define your methods here
const isChecked = (arrayIds, id) => {
  const data = arrayIds.filter(function (el) {
    return parseInt(el, 10) === parseInt(id, 10);
  });

  return (data.length > 0);
}

const showInfoPackForm = async (careHomeId, careHomeName, action, e) => {
  globalStore.setModal(
    {
      name: 'villageInfoPackModal',
      id: careHomeId,
      customField: action,
      title: careHomeName,
      descriptionPlaceholder: 'Please include any relevant information e.g. level of care required, who care is for and how soon care is needed.',
    }
  )

  await nextTick()
  const ele = e.target;
  document.getElementById('property_name').value = careHomeName
  document.getElementById('operator_name').value = ele.dataset.operatorName
  document.getElementById('operator_id').value = ele.dataset.operatorId
  document.getElementById('subscription').value = ele.dataset.subscription
  document.getElementById('enquiry_region').value = ele.dataset.enquiryRegion
  document.getElementById('enquiry_district').value = ele.dataset.enquiryDistrict
}

const toggleCompareList = () => {
  if (compareStore.careHomeCompareList.length > 0) {
    compareStore.setShowCareHomeCompareList(!compareStore.careHomeCompareList)
    submitCompareNow()
  }
}

const closeCompareList = () => {
  compareStore.setShowCareHomeCompareList(false)
}

const submitCompareNow = () => {
  const result = compareStore.careHomeCompareList.map(function (list) {
    return list.id;
  }).join(',');

  window.location.href = `/rest-homes-compare?compareList=${result}&region=${filterStore.region.id}&district=${filterStore.district.id}&suburbs=${JSON.stringify(filterStore.suburbs)}`;
}

const toggleModal = (modalName, showFooter) => {
  globalStore.setModal(
    {
      name: modalName,
      showFooter: showFooter,
    }
  )
}

const showManagerNumber = (id) => {
  if (id === data.compareActiveNumberId) {
    data.compareActiveNumberId = false;
  } else {
    data.compareActiveNumberId = id;
  }
}

const toggleMap = () => {
  data.showFullMap = !data.showFullMap;
}

onMounted(() => {
  if (props.careHomeImpressionList.items.length > 0) {
    productImpression(props.careHomeImpressionList);
  }

  data.mySiteKeyVariable = document.getElementById('mySiteKeyVariable').value
  compareStore.setCareHomeCompareList(props.compareList)
  compareStore.setShowCareHomeCompareList(false)

  if (window.innerWidth < 768) {
    data.showMap = false;
  }
})

</script>
